let projectConfig = window.projectConfig;
let ProjectConfigDetailData = sessionStorage.getItem('ProjectConfigDetailData');

//缓存有数据
if(ProjectConfigDetailData){
	ProjectConfigDetailData =  JSON.parse( ProjectConfigDetailData || '{}');
}

if(projectConfig){
	if(ProjectConfigDetailData){
		//存在,更新数据在home页,判断是不是mvno数据
		if(location.pathname  == "/Home" && location.search.indexOf('projectConfig') != -1){
			sessionStorage.setItem('ProjectConfigDetailData', JSON.stringify(projectConfig));		
		}else{
			//不在需要还原缓存数据
			projectConfig = ProjectConfigDetailData;
		}
	}else{
		//不存在直接设置
		sessionStorage.setItem('ProjectConfigDetailData', JSON.stringify(projectConfig));
	}
}else{
	if( ProjectConfigDetailData ){
		projectConfig = ProjectConfigDetailData;
	}else{
		projectConfig = false;
	}
}

export default projectConfig;